export default {
    name_management_area: 'Name Verwaltungsbereich',
    name_application_area: 'Name Antragsbereich',
    model_class: 'Gehört zu',
    sort: 'Sortierung',
    statusNotifications: 'Statusbenachrichtigungen',

    model_classes: {
        FormProcess: 'Formular',
        Process: 'Vorgang',
        StatisticProcess: 'Statistik',
    },

    qf_modelClassProcessOnly: 'Nur Vorgangsstatus',
    qf_modelClassFormProcessOnly: 'Nur Formularstatus',
    qf_modelClassStatisticProcessOnly: 'Nur Statistikstatus',
}